import { UserManagementService } from "../core/user-management-service";

export class LocalUserManagementService extends UserManagementService {
    getUserManagementUrl = () => `https://localhost:5001/api/user-management`;
    getUserMenuUrl = () => `https://localhost:5001/api/user-info/user-menu`;
    getUserInfoUrl = () => `https://localhost:5001/api/user-info`;
}
